import { jsxs as r, jsx as C } from "react/jsx-runtime";
function h(i) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "18",
      height: "16",
      viewBox: "0 0 18 16",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...i,
      children: [
        /* @__PURE__ */ C("g", { clipPath: "url(#clip0_18606_11175)", children: /* @__PURE__ */ C("path", { d: "M4.225 0.553125L4 1H1C0.446875 1 0 1.44687 0 2C0 2.55312 0.446875 3 1 3H13C13.5531 3 14 2.55312 14 2C14 1.44687 13.5531 1 13 1H10L9.775 0.553125C9.60625 0.2125 9.25938 0 8.88125 0H5.11875C4.74062 0 4.39375 0.2125 4.225 0.553125ZM13 4H1L1.6625 14.5938C1.7125 15.3844 2.36875 16 3.15937 16H10.3375C8.925 15.0031 8 13.3594 8 11.5C8 8.675 10.1313 6.34688 12.8719 6.03438L13 4ZM18 11.5C18 9.01562 15.9844 7 13.5 7C11.0156 7 9 9.01562 9 11.5C9 13.9844 11.0156 16 13.5 16C15.9844 16 18 13.9844 18 11.5ZM13.5 9C13.775 9 14 9.225 14 9.5V11H15C15.275 11 15.5 11.225 15.5 11.5C15.5 11.775 15.275 12 15 12H13.5C13.225 12 13 11.775 13 11.5V9.5C13 9.225 13.225 9 13.5 9Z" }) }),
        /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_18606_11175", children: /* @__PURE__ */ C("rect", { width: "18", height: "16" }) }) })
      ]
    }
  );
}
export {
  h as TrashClockIcon
};
